import { render, staticRenderFns } from "./ChannelMain.vue?vue&type=template&id=187df13c&"
import script from "./ChannelMain.vue?vue&type=script&lang=js&"
export * from "./ChannelMain.vue?vue&type=script&lang=js&"
import style0 from "./ChannelMain.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTable,QInput,QIcon} from 'quasar'
component.options.components = Object.assign({QBtn,QTable,QInput,QIcon}, component.options.components || {})
